import axios from "axios";
import { documents, proxy } from "@/urls";

export default {
  namespaced: true,
  state: {
    data: [],
    dataInv: [],
    current: {},
    docsNonLetti: null,
  },
  getters: {
    data: (state) => state.data,
    dataInv: (state) => state.dataInv,
    current: (state) => state.current,
    docsNonLetti: (state) => state.docsNonLetti,
  },
  mutations: {
    SET_DATA(state, data) {
      state.data = data;
    },
    SET_DATA_INV(state, data) {
      state.dataInv = data;
    },
    SET_CURRENT(state, data) {
      state.current = data;
    },
    SET_DOCSNONLETTI(state, data) {
      state.docsNonLetti = data;
    },
    DECREASE_DOCSNONLETTI(state) {
      state.docsNonLetti--;
    },
    UNMARK_DOC(state, id) {
      const i = state.data.findIndex((item) => item.id === id);
      state.data[i].letto = 2;
    },
  },
  actions: {
    setDocsnonletti({ commit }, data) {
      commit("SET_DOCSNONLETTI", data);
    },
    resetCurrent({ commit }) {
      commit("SET_CURRENT", {});
    },
    resetData({ commit }) {
      commit("SET_DATA", []);
    },
    resetDataInv({ commit }) {
      commit("SET_DATA_INV", []);
    },
    async fetchDocuments(
      { dispatch, commit, rootGetters },
      payload = { da: null, a: null }
    ) {
      commit("SET_DATA", []);
      try {
        const account = rootGetters["account/account"];
        const { data } = await axios.get(
          `${documents.FETCH_DOCUMENTS_URL}/${account.codFiscale}`,
          { params: { filtroOrigine: 1, data_da: payload.da, data_a: payload.a } }
        );
        commit("SET_DATA", data);
      } catch (err) {
        dispatch("snackbar/openErrorSnackbar", err, { root: true });
      }
    },
    downloadDocument({ dispatch, commit }, payload) {
      axios({
        url: `${documents.DOWNLOAD_DOCUMENT_URL}/${payload.id}`,
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          var extension = payload.nomeFile.split(".").pop();
          if (extension !== "pdf") {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");

            fileLink.href = fileURL;
            const nomeFile = payload.descrizione
              ? `${payload.descrizione}_${
                  payload.dataConsegna ? payload.dataConsegna.slice(0, 10) : ""
                }.${payload.nomeFile.slice(-3)}`
              : payload.nomeFile;
            fileLink.setAttribute("download", nomeFile);
            document.body.appendChild(fileLink);

            fileLink.click();
          } else {
            var file = new Blob([response.data], { type: "application/pdf" });
            var url = URL.createObjectURL(file);
            window.open(url);
          }

          if (!payload.letto == 2) {
            commit("DECREASE_DOCSNONLETTI");
            commit("UNMARK_DOC", payload.id);
          }
        })
        .catch((err) =>
          dispatch("snackbar/openErrorSnackbar", err, { root: true })
        );
    },
    async uploadDocument({ dispatch, rootGetters }, item) {
      try {
        const account = rootGetters["account/account"];
        await axios.post(proxy.UPLOAD_DOCUMENT_URL_1, {
          codAzienda: account.azienda.idAzienda,
          descrizione: item.name,
          nomeFile: item.name,
          dataConsegna: new Date().toISOString().split("T")[0],
          codiceFiscale: account.codFiscale,
          visibileWeb: true,
        });

        await axios.post(
          `${proxy.UPLOAD_DOCUMENT_URL_2}/${account.azienda.idAzienda}/${item.name}`,
          item,
          { headers: { "Content-Type": "application/pdf" } }
        );

        dispatch("snackbar/openSnackbar", "Documento inviato con successo", {
          root: true,
        });
      } catch (err) {
        dispatch("snackbar/openErrorSnackbar", err, { root: true });
      }
    },
    async fetchDocumentsInv(
      { dispatch, commit, rootGetters },
      payload = { da: null, a: null }
    ) {
      commit("SET_DATA_INV", []);
      try {
        const account = rootGetters["account/account"];
        const { data } = await axios.get(
          `${documents.FETCH_DOCUMENTS_URL}/${account.codFiscale}`,
          { params: { filtroOrigine: 2, data_da: payload.da, data_a: payload.a } }
        );
        commit("SET_DATA_INV", data);
      } catch (err) {
        dispatch("snackbar/openErrorSnackbar", err, { root: true });
      }
    },
  },
};
